import React from "react";
import { Progress } from "@/components/ui/progress";

const SCORE_ORDER = [
  "status", "authority", "movement", "wealth", "luxury", "desire",
  "emotional_pull", "mystery", "memorability", "cultural_charge",
  "brand_usefulness", "doctrine_depth", "shadow_risk",
];

const LABELS = {
  status: "Status", movement: "Movement", wealth: "Wealth", desire: "Desire",
  authority: "Authority", mystery: "Mystery", luxury: "Luxury",
  emotional_pull: "Emotional Pull", shadow_risk: "Shadow Risk",
  memorability: "Memorability", cultural_charge: "Cultural Charge",
  brand_usefulness: "Brand Usefulness", doctrine_depth: "Doctrine Depth",
};

export const ScoreBars = ({ scores, compact = false, limit }) => {
  if (!scores) return null;
  let keys = SCORE_ORDER.filter((k) => k in scores);
  if (limit) {
    keys = [...keys].sort((a, b) => scores[b] - scores[a]).slice(0, limit);
  }
  return (
    <div className={compact ? "space-y-2" : "grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3"} data-testid="score-bars">
      {keys.map((k) => {
        const v = scores[k];
        const isShadow = k === "shadow_risk";
        return (
          <div key={k} data-testid={`score-${k}`}>
            <div className="flex items-center justify-between mb-1">
              <span className="text-xs text-[var(--bone-muted)]">{LABELS[k]}</span>
              <span className={`mono-chip ${isShadow && v >= 55 ? "text-[#C08A2A]" : "text-[var(--bone)]"}`}>{v}</span>
            </div>
            <div className="h-1.5 w-full rounded-full bg-white/[0.06] overflow-hidden">
              <div
                className="h-full rounded-full"
                style={{
                  width: `${v}%`,
                  background: isShadow
                    ? "linear-gradient(90deg, rgba(192,138,42,0.5), rgba(192,138,42,0.9))"
                    : "linear-gradient(90deg, rgba(20,90,67,0.7), rgba(46,158,118,0.95))",
                  transition: "width 500ms cubic-bezier(0.2,0.8,0.2,1)",
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ScoreBars;
